export default {
  feedback:{
    success: '#198038',
    successLight: '#ECFFF2',
    error: '#DA1E28',
    errorHover: '#ED8288',
    errorLight: '#FFE7E8',
    alert: '#FFD80C',  
  },
  brand:{
    blueOmint:'#001689',
    white:'#FFFFFF',
    green:'#00977E',
    blueDark: '#000A40',
    lightGreen: '#E0F2F1',
    darkGreen: '#26827F',
    selectGreen:'#0F7B61',
    yellow: '#F6A41D',
    white: '#FFFFFF',
    backgroundBlue: '#EFF5FF',
    lightBlue:'#3076D0',
  },
  greys:{
    dividerGray:'#E0E0E0',
    disabledGrey:'#767676',
    defaultBorder:'#989898',
    disabledBackground:'#F2F2F2',
    disabled:"#B8B8B8"
  },
  text:{
    primaryText:'#161616',
    secondaryText: '#525252',
    tertiaryText: '#BCBABA',
  },
  darkishBlue: '#023979',
  darkishBlueTwo: '#174984',
  lightBlue: '#0092ff',
  lightBlueTwo: '#add8e6',
  warmGrey: '#9e9e9e',
  warmGreyTwo: '#616161',
  cloudyBlueTwo: '#c2cdda',
  cloudyBlueThree: '#ecf0f3',
  white: '#e0e0e0',
  whiteTwo: '#cbcbcb',
  green: '#04705e',
  greenTwo: '#00b496',
  greenThree: '#015445',
  greenFour: '#ecf3ef',
  red: '#e2cccf',
  redTwo: '#700210',
  redThree: '#c0bcbc',
  grey: '#c6cbd4',
  greyTwo: '#333333',
  greyThree: '#9b9b9b',
  greyFour: '#827f7f',
  greyFive: '#f6f5f5',
  greySix: '#7f8fa4',
  black: '#212121',
  congressBlue: '#003d82',
}
